import {Injectable} from '@angular/core';
import {AbstractService} from './abstract.service';
import {ApiVersion} from '../constants/apis';
import {FinraSettings, LabelSettings, ProjectSettings, TechnicalLibrarySettings} from '../models/admin.model';
import {HttpClient, HttpHeaders, HttpParams} from '@angular/common/http';
import {Observable} from 'rxjs';
import {StorageService} from './storage.service';


@Injectable({
  providedIn: 'root'
})
export class AdminService extends AbstractService {

  constructor(private http: HttpClient,
              private storageService: StorageService) {
    super();
  }

  getFinraSettings(): Observable<LabelSettings> {
    const url = this.toFinraApiServiceUrl(ApiVersion.V1, 'settings');
    let params = new HttpParams().set("domain", this.storageService.getDomain());
    const options = {params};
    return this.http.get<LabelSettings>(url, options);
  }

  getLabelSettings(): Observable<LabelSettings> {
    const url = this.toFinraApiServiceUrl(ApiVersion.V1, 'settings/label');
    let params = new HttpParams().set("domain", this.storageService.getDomain());
    const options = {params};
    return this.http.get<LabelSettings>(url, options);
  }

  getProjectSettings(): Observable<ProjectSettings> {
    const url = this.toFinraApiServiceUrl(ApiVersion.V1, 'settings/project');
    let params = new HttpParams().set("domain", this.storageService.getDomain());
    const options = {params};
    return this.http.get<ProjectSettings>(url, options);
  }

  getTechnicalLibraries(): Observable<TechnicalLibrarySettings> {
    const url = this.toFinraApiServiceUrl(ApiVersion.V1, 'settings/technical/library');
    let params = new HttpParams().set("domain", this.storageService.getDomain());
    const options = {params};
    return this.http.get<TechnicalLibrarySettings>(url, options);
  }

  createTechnicalLibraries(): Observable<void> {
    const url = this.toFinraApiServiceUrl(ApiVersion.V1, 'settings/technical/library');
    let params = new HttpParams().set("domain", this.storageService.getDomain());
    const options = {params};
    return this.http.post<void>(url, null, options);
  }

  createDriveLabel(labelsAccessToken: string): Observable<FinraSettings> {
    const url = this.toFinraApiServiceUrl(ApiVersion.V1, 'settings/label');
    let params = new HttpParams().set("domain", this.storageService.getDomain());
    // Sent in place of the session token: label creation needs the drive.admin.labels scope.
    const headers = new HttpHeaders().set('Authorization', `Bearer ${labelsAccessToken}`);
    const options = {params, headers};
    return this.http.post<FinraSettings>(url, null, options);
  }

  enterProjectSettings(project: string, bucket: string): Observable<FinraSettings> {
    const url = this.toFinraApiServiceUrl(ApiVersion.V1, 'settings/project');
    let params = new HttpParams().set("domain", this.storageService.getDomain());
    const options = {params};
    return this.http.post<FinraSettings>(url, {project, bucket}, options);
  }

  configureFinraLibrary(libraryId: string): Observable<string[]> {
    const url = this.toFinraApiServiceUrl(ApiVersion.V1, 'settings/library/' + libraryId);
    let params = new HttpParams().set("domain", this.storageService.getDomain());
    const options = {params};
    return this.http.post<string[]>(url, null, options);
  }
}
